import { PlanType } from '@labrav/react-components'
import type { CombinedFormState } from '../types'

export const processGetCombinedFormData = (
  data: any,
  productType?: PlanType
): CombinedFormState => {
  const { detailsJson, ...rest } = data

  if (
    detailsJson.resellerAgreementData === null ||
    detailsJson.cppoData === null
  ) {
    return {
      ...rest,
      ...detailsJson,
    }
  }
  const resellerAgreementData = detailsJson?.resellerAgreementData
  let contractDuration =
    resellerAgreementData?.contractDurationInMonthsForEndCustomer
  if (
    resellerAgreementData?.contractDurationTimeUnit === 'YEARS' &&
    resellerAgreementData?.contractDurationInMonthsForEndCustomer &&
    resellerAgreementData.productType !== PlanType.SAAS_SUBSCRIPTION
  ) {
    const months = Number(
      resellerAgreementData.contractDurationInMonthsForEndCustomer
    )
    contractDuration = months / 12
  }

  const updatedDetailsJson = {
    ...detailsJson,
    resellerAgreementData: {
      ...detailsJson.resellerAgreementData,
      contractDurationInMonthsForEndCustomer: contractDuration,
    },
    cppoData: {
      ...detailsJson?.cppoData,
      adjustmentPercentageInputValue: detailsJson.cppoData.adjustmentPercentage,
    },
  }

  const updatedJson = {
    ...rest,
    ...updatedDetailsJson,
  }

  return updatedJson
}
